var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "advanced-file-picker-component",
      style: { height: _vm.size, width: _vm.size },
    },
    [
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          id: _vm.id,
          name: _vm.name,
          accept: _vm.acceptedTypes,
          disabled: _vm.disabled,
        },
        on: { change: _vm.onFileChanged },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "file-content",
          class: { "has-file": _vm.hasFile, disabled: _vm.disabled },
          style: { height: _vm.size, width: _vm.size },
          on: { click: _vm.openFileDialog },
        },
        [
          _vm.hasFile
            ? _c("div", { staticClass: "file-display" }, [
                _vm.isLoading
                  ? _c("div", { staticClass: "loading" }, [
                      _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Carregando...")]),
                    ])
                  : _vm.type === "image" && _vm.previewUrl
                  ? _c("img", {
                      staticClass: "image-preview",
                      attrs: { src: _vm.previewUrl, alt: _vm.currentFileName },
                    })
                  : _vm.currentFileName
                  ? _c("div", { staticClass: "file-info" }, [
                      _c("i", {
                        staticClass: "file-icon",
                        class: _vm.getFileIcon(),
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "file-name" }, [
                        _vm._v(_vm._s(_vm.currentFileName)),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _c("div", { staticClass: "placeholder" }, [
                _c("i", { staticClass: "upload-icon fas fa-upload" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
              ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }